import React from "react";
import PropTypes from "prop-types";
import { getLinkToProject } from "../../common/util/pathUtils";

const SingleProject = ({ project, showLearnMore }) => {
    const linkToProject = getLinkToProject(project.code);

    return <div className="w-100 con-justify text-left shadow">
                <div className="up">
                    <div className="h-240px w-100 img-cover" style={{ backgroundImage: `url(${project.thumbnailImageUrl})` }}> </div>
                    <div className="px-3 py-2">
                        <h6 className="text-primary">{project.locationDescription}</h6>
                        <h4><a target="_blank" href="{linkToProject}" className="text-secondary">{project.name}</a></h4>
                        <p className="text-light xsml mt-0">{project.shortDescription}</p>
                    </div>
                </div>
                {showLearnMore &&
                <div className="down px-3"><a target="_blank" href={linkToProject} className="text-primary">Learn more</a></div>
                }
            </div>
}

SingleProject.propTypes = {
    project: PropTypes.object,
    showLearnMore: PropTypes.bool
}

export default SingleProject;